// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1be59d50","952":"df5b9dbb"}[chunkId] + ".chunk.js";
};